<template>
  <div v-if="visible" class="popup" :style="{'z-index':zIndex||'9999'}">
    <div class="popup_fluid" v-if="!hidePopUp_Fluid"></div>
    <div
      @animationend="animateEnd"
      class="popup_box rule_box"
      :class="{ pulldown: animateType == 'down', pullup: animateType == 'up' }"
    >
      <slot></slot>
      <img v-if="!hideCloseBtn"
        src="https://picbed.qunarzz.com/97abd96569f0c114c30fb27765571041.png"
        @click="close"
        class="yo-ico m-touch-login__close fingerTouch close"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: ["value",'hideCloseBtn','hidePopUp_Fluid','zIndex'],
  data() {
    return {
      visible:false,
      animate: false,
      animateType: "down",
      scroll: ""
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        /* 弹框显示时动画状态变为up,隐藏时状态变为down */
        document.body.style["overflow"] = "hidden";
      } else {
        // document.body.style["overflow-y"] = "auto";
      }
    }
  },
  methods: {
    close() {
      // document.body.style["overflow-y"] = "scroll";
      this.animateType = "up";
    },
    show(){
      this.visible = true;
      document.body.style["overflow"] = "hidden";
      this.animateType = "down";
    },
    closeEmit() {
      this.$emit("close", this.close);
    },
    animateEnd() {
      if (this.animateType == "up") {
        /* 只在弹框隐藏时触发该方法 */
        this.visible = false;
        this.animateType = "down";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  &_fluid {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  &_box {
    border-radius: 6px;
    min-width: 350px;
    min-height: 100px;
    z-index: 10;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .gift {
    width: 100%;
    display: block;
  }

  .back {
    position: absolute;
    bottom: 0;
    height: 42px;
    transform: translateX(-50%);
    left: 50%;
  }

  .close {
    position: absolute;
    width: 36px;
    height: 36px;
    left:50%;
    margin-left:-18px;
    bottom:-50px;
  }
}

.rule_cont {
  color: #fff;
  font-size: 7px;
  padding-left: 15px;
  padding-right: 15px;
  max-height: 300px;
  overflow-y: scroll;
  padding-bottom: 15px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.common_tit {
  height: 26px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 12px;
}

.pulldown {
  animation: pullDown 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.pullup {
  animation: pullUp 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

@keyframes pullDown {
  0% {
    transform: translate(-50%, calc(-50% - 300px));
    opacity: 0;
  }

  100% {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

@keyframes pullUp {
  0% {
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, calc(-50% - 300px));
    opacity: 0;
  }
}
</style>